const getNewFilename = (filename) => {
  const regexExtension = /(?:\.([^.]+))?$/;
  const timestamp = `${Date.now()}`;
  const extension = regexExtension.exec(filename)[1];

  return extension ? `${timestamp}.${extension}` : `${timestamp}`;
};

export default getNewFilename;
